import React, {useState} from "react";
import {Columns, Heading, Modal, Section, Form, Button} from "react-bulma-components";
import {formatDate, movementCost} from "../../utils";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import MovementRatePicker from "./MovementRatePicker";
import useSelect from "../../hooks/useSelect";
import useButtonSelect from "../../hooks/useButtonSelect";
import MovementTypePicker from "../Settings/MovementType/MovementTypePicker";
import DriverPicker from "../Settings/Driver/DriverPicker";
import WorkTypePicker from "../Job/WorkTypePicker";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import CreateNewContactModal from "../Contact/CreateNewContactModal";

const AsyncTypeahead = asyncContainer(Typeahead);

export default function CreateMovement({endpoint, autoFill, open, setOpen, dataFresh, movementRateOptions, movementRateObjects, movementTypeOptions, movementTypeObjects, driverOptions, driverObjects, workTypes={results: []}, workTypeObjects, departments, departmentObjects, movementRateParams, setMovementRateParams}){
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [typeahead, setTypeahead] = useState();
    const [customerCreateModalOpen, setCustomerCreateModalOpen] = useState(false);

    const onChange = e => {
        let updatedMovement = {...movement, [e.target.name] : e.target.value};
        updatedMovement = movementCost(updatedMovement);
        setMovement(updatedMovement);
    };


    const options = [
        {name: "Normal", value: "NORMAL"},
         {name: "Quote", value: "QUOTE"}
    ];

    const customerPaymentOptions = [
        {name:"", value: "BLANK"},
        {name: "BACS", value: "BACS"},
        {name: "CASH", value: "CASH"},
        {name: "CARD", value: "CARD"},
        {name: "DIRECT DEBIT", value: "DIRECT DEBIT"}
    ];

    const supplierStatusOptions = [
        {name: "Internal", value: "INTERNAL"},
        {name: "External", value: "EXTERNAL"}
    ]

    let customerOptions = (autoFill && autoFill.customers) ?
        autoFill.customers.reduce((prev, current) => {
            return [...prev, {name: current.display_name, value: current.id}]
        }, []) : []

    const customerObjects = (autoFill && autoFill.customers) ? autoFill.customers.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {}) : [];


    const onCustomerSelect = e =>{
        const toUpdate = {
            target: {
                name: e.target.name,
                value: customerObjects[e.target.value]
            }
        };
        // this is to handle them clearing the contact (do not know why they would want to but it shouldnt error when they do)
        let newRateParams = {...movementRateParams}
        if(e.target.value) {
            newRateParams.contact = customerObjects[e.target.value].id;

        }
        else{
            delete newRateParams['contact'];
        }
        setMovementRateParams(newRateParams);
        onChange(toUpdate);
    }

    const onDriverSelect = e =>{
        const toUpdate = {
            target: {
                name: e.target.name,
                value: driverObjects[e.target.value]
            }
        };
        onChange(toUpdate);
    }

    const [statusOption, statusOptionInput] = useButtonSelect({
        label: "Status",
        initialValue: "NORMAL",
        prop: "movement_status",
        options: options,
        callback: onChange
    });

    const [supplierStatus, supplierStatusInput] = useButtonSelect({
        label: "Supplier Status",
        initialValue: "INTERNAL",
        prop: "supplier_status",
        options: supplierStatusOptions,
        callback: onChange
    });

    const [movement, setMovement] = useState({
        job: autoFill ? autoFill.job : null,
        rental: autoFill ? autoFill.rental : null,
        movement_rate: movementRateObjects[Object.keys(movementRateObjects)[0]], // Finds first element in dictionary
        vehicle: autoFill ? autoFill.vehicle : "",
        customer: null, //(autoFill && autoFill.customers && autoFill.customers[0]) ? customerObjects[customerOptions[0].value] :
        start_address: "",
        end_address: "",
        delivery_date: formatDate(new Date),
        cost: 0,
        internal_charge: 0,
        comments: "",
        miles: 0,
        cost_override: false,
        supplier_cost_override: false,
        movement_status: "NORMAL",
        start_time: "",
        end_time: "",
        movement_type: movementTypeObjects[Object.keys(movementTypeObjects)[0]],
        vehicle_used: null,
        driver: null,
        department: autoFill ? autoFill.department : {id: 1, name: "Rentals Direct"},
        movement_performer: autoFill ? autoFill.movement_performer : {id: 1, name: "Rentals Direct"},
        order_number: "",
        supplier_status: "INTERNAL",
        external_supplier: null,
        external_supplier_charge: 0,
        external_supplier_charge_override: false,
        customer_paid_amount: 0,
        customer_payment_method: "",
        cash_sale: [
            { //The contact will be added in the onSave function
                name: "",
                address: "",
                phone: "",
                email: ""
            }
        ]
    });

    const handleRateChange = e => {
        let toUpdate = {
            target: {
                name: e.target.name,
                value: movementRateObjects[e.target.value]
            }
        }
        onChange(toUpdate);
    }
    const handleWorkTypeChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: workTypeObjects[e.target.value]
            }
        }
        onChange(toUpdate);
    }
    const handleTypeChange = e => {
        let toUpdate = {
            target: {
                name: e.target.name,
                value: movementTypeObjects[e.target.value]
            }
        }
        onChange(toUpdate);
    }

    const handleDepartmentChange = e => {
        let toUpdate = {
            target: {
                name: e.target.name,
                value: departmentObjects[e.target.value]
            }
        };
        onChange(toUpdate);
    }

    const validator = (data) => {
        if(data.job){
            if(!(data.work_type)){
                return false
            }
        }
        if(data.customer.is_cash_sale){
            if(!(!!data.cash_sale[0].name)){
                return false;
            }
            if(!(!!data.cash_sale[0].address)){
                return false;
            }
        }
        return true
    }
    const save = () => {
        if(validator(movement)) {
            let movementToSend = movement;
            if(movement.customer && movement.customer.is_cash_sale){
                // we need some way of handling this so that even with auto fill the contact is set correctly on cash sale
                let cashSale = {...movement.cash_sale[0]};
                cashSale.contact=movement.customer.id;
                let updatedMovement = {...movement, cash_sale: [cashSale]};
                movementToSend = updatedMovement
            }
            else{
                // Clear cash sale as no data is needed
                movementToSend.cash_sale = []
            }
            let conf = {
                url: endpoint + "movement",
                method: "post",
                data: movementToSend
            };
            let fieldsToCheck = ['vehicle', 'customer'];
            fieldsToCheck.forEach((field) => {
                if(autoFill && movementToSend) {
                    if (!(!!movementToSend[field]) && autoFill[field]) {
                        movementToSend[field] = autoFill[field];
                    }
                }
            });
            axios(conf).then(() => {
                dispatch(createSetDataFreshAction(dataFresh + 1));
                setOpen(false);
            }).catch(() => {
                NotificationManager.error("There was an error creating the movement")
            });
        }
        else{
            NotificationManager.warning("Workshop Expense Charge Type is required for work items created from a job")
        }
    }
    const handleCustomerSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `contacts?contact_type=CC&page_size=40&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const handleSupplierSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `contacts?contact_type=SP&page_size=40&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const handleVehicleSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `vehicles?showAll=true&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const onCostOverrideCheck = e => {
        let updatedMovement = {...movement, [e.target.name] : e.target.checked};
        updatedMovement = movementCost(updatedMovement);
        setMovement(updatedMovement);
    };

    const onCustomerChange = e => {
        let updatedMovement = {...movement, "customer": e[0]}
        let newParams = {...movementRateParams};
        if(!!e[0]) {
            newParams.contact = e[0].id;
            setMovementRateParams(newParams);
        }
        setMovement(updatedMovement);
    };

    const onExternalSupplierChange = e => {
        let updatedMovement = {...movement, "external_supplier": e[0]}
        setMovement(updatedMovement);
    }

    const onVehicleUsedChange = e => {
        let updatedMovement = {...movement, "vehicle_used": e[0]}
        setMovement(updatedMovement);
    };

    const onCashSaleChange = e => {
        let cashSale = {...movement.cash_sale[0]};
        cashSale[e.target.name] = e.target.value;
        let updatedMovement = {...movement, cash_sale:[cashSale]}
        setMovement(updatedMovement);
    }

    return (
        <Modal
            show={open}
            closeOnBlur
            onClose={()=>{
                setOpen(false)
            }}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column size={6}>
                            <Heading>Create Movement</Heading>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                onClick={() => setCustomerCreateModalOpen(true)}
                            >
                                Create New Contact +
                            </Button>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column size={6}>
                            <h2 className={"title"}>Movement and customer details</h2>
                        </Columns.Column>
                        <Columns.Column>
                            {statusOptionInput}
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <DepartmentSelector
                                name={"department"}
                                value={movement.department}
                                editable={true}
                                inlineEdit={false}
                                disabled={false}
                                onChange={handleDepartmentChange}
                                options={departments}
                                blank={false}
                                classname={""}
                                label={"Customer Charger"}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <MovementTypePicker
                                options={movementTypeOptions ?? {results: []}}
                                value={movement.movement_type}
                                editable={true}
                                label={"Type"}
                                onChange={handleTypeChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Vehicle / Job Description</Form.Label>
                                <Form.Input
                                    name={"vehicle"}
                                    onChange={onChange}
                                    type={"text"}
                                    value={autoFill ? autoFill.vehicle : movement.vehicle}
                                />
                            </Form.Field>
                        </Columns.Column>
                        {!autoFill &&
                            <Columns.Column>
                                <Form.Label>Customer</Form.Label>
                                <AsyncTypeahead
                                  useCache={false}
                                  isLoading={loading}
                                  id="typeahead"
                                  labelKey="display_name"
                                  minLength={2}
                                  name={"customer"}
                                  onSearch={handleCustomerSearch}
                                  onChange={onCustomerChange}
                                  placeholder={`Search Customer`}
                                  options={searchData}
                                  ref={typeahead => setTypeahead(typeahead)}
                                  className="typeahead"
                                />
                            </Columns.Column>
                        }
                        {autoFill && autoFill.customers &&
                            <Columns.Column>
                              <Form.Field>
                                <Form.Label>Customer</Form.Label>
                                <Form.Control>
                                  <Form.Select
                                      value={movement.customer ? movement.customer.id : -1}
                                      onChange={onCustomerSelect}
                                      name={"customer"}
                                  >
                                    <option key={-1} value={null}></option>
                                    {customerOptions.map(item => (
                                      <option key={item.name} value={item.value}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Form.Control>
                              </Form.Field>
                            </Columns.Column>
                        }
                        {autoFill && autoFill.job &&
                            <Columns.Column>
                                <WorkTypePicker
                                    options={workTypes}
                                    work={movement}
                                    showTitle={true}
                                    editable={true}
                                    onSelect={handleWorkTypeChange}
                                    inlineEdit={false}
                                />
                            </Columns.Column>
                        }
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Order Number</Form.Label>
                                <Form.Input
                                    type={"text"}
                                    name={"order_number"}
                                    onChange={onChange}
                                    value={movement.order_number}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Start Address</Form.Label>
                                <Form.Textarea
                                    name={"start_address"}
                                    onChange={onChange}
                                    value={movement.start_address}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>End Address</Form.Label>
                                <Form.Textarea
                                    name={"end_address"}
                                    onChange={onChange}
                                    value={movement.end_address}
                                />
                            </Form.Field>
                        </Columns.Column>
                    </Columns>
                    {(movement.customer && movement.customer.is_cash_sale) &&
                        <Columns>
                            <Columns.Column>
                                <Heading>Cash Sale Info</Heading>
                            </Columns.Column>
                        </Columns>
                    }
                    {(movement.customer && movement.customer.is_cash_sale) &&
                        <Columns>
                            <Columns.Column>
                                <Form.Label>Name</Form.Label>
                                <Form.Input
                                    name={"name"}
                                    value={movement.cash_sale[0].name}
                                    onChange={onCashSaleChange}
                                    type={"text"}
                                />
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Label>Email</Form.Label>
                                <Form.Input
                                    name={"email"}
                                    value={movement.cash_sale[0].email}
                                    onChange={onCashSaleChange}
                                    type={"email"}
                                />
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Label>Phone</Form.Label>
                                <Form.Input
                                    name={"phone"}
                                    value={movement.cash_sale[0].phone}
                                    onChange={onCashSaleChange}
                                    type={"text"}
                                />
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Label>Address</Form.Label>
                                <Form.Input
                                    name={"address"}
                                    value={movement.cash_sale[0].address}
                                    onChange={onCashSaleChange}
                                    type={"text"}
                                />
                            </Columns.Column>
                        </Columns>
                    }
                    <Columns>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Delivery Date</Form.Label>
                                <Form.Input
                                    name={"delivery_date"}
                                    onChange={onChange}
                                    type={"date"}
                                    value={movement.delivery_date}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Start Time</Form.Label>
                                <Form.Input
                                    name={"start_time"}
                                    onChange={onChange}
                                    type={"time"}
                                    value={movement.start_time}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>End Time</Form.Label>
                                <Form.Input
                                    name={"end_time"}
                                    onChange={onChange}
                                    type={"time"}
                                    value={movement.end_time}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <MovementRatePicker
                                options={movementRateOptions ?? {results: []}}
                                onChange={handleRateChange}
                                movement={movement}
                                label={"Movement Rate"}
                                blank={true}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Movement Rate Comments</Form.Label>
                            <Form.Textarea
                                disabled={true}
                                value={movement.movement_rate ? movement.movement_rate.comments : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Cost Override</Form.Label>
                                <Form.Checkbox
                                    name={"cost_override"}
                                    checked={movement.cost_override}
                                    onChange={onCostOverrideCheck}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Miles</Form.Label>
                                <Form.Input
                                    name={"miles"}
                                    onChange={onChange}
                                    type={"number"}
                                    value={movement.miles}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Customer Cost</Form.Label>
                                <Form.Input
                                    name={"cost"}
                                    onChange={onChange}
                                    type={"number"}
                                    value={movement.cost}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Customer Amount Paid</Form.Label>
                            <Form.Input
                                type={"number"}
                                name={"customer_paid_amount"}
                                value={movement.customer_paid_amount}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Customer Payment Method</Form.Label>
                            <Form.Select
                              name={"customer_payment_method"}
                              value={movement.customer_payment_method}
                              onChange={onChange}
                            >
                              {customerPaymentOptions.map(method => (
                                  <option value={method.value}>{method.name}</option>
                              ))}
                            </Form.Select>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column></Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <h2 className={"title"}>Who is doing the movement</h2>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        {supplierStatusInput}
                        <Columns.Column>
                            <DepartmentSelector
                                name={"movement_performer"}
                                value={movement.movement_performer}
                                editable={true}
                                inlineEdit={false}
                                disabled={false}
                                onChange={handleDepartmentChange}
                                options={departments}
                                blank={false}
                                classname={""}
                                label={"Supplier"}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Vehicle Used</Form.Label>
                            <AsyncTypeahead
                              useCache={false}
                              isLoading={loading}
                              id="typeahead"
                              labelKey="registration"
                              minLength={2}
                              name={"vehicle_used"}
                              onSearch={handleVehicleSearch}
                              onChange={onVehicleUsedChange}
                              placeholder={`Search Vehicle`}
                              options={searchData}
                              ref={typeahead => setTypeahead(typeahead)}
                              className="typeahead"
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <DriverPicker
                                options={driverOptions}
                                label={"Driver"}
                                onChange={onDriverSelect}
                                blank={true}
                                disabled={false}
                                inlineEdit={false}
                                editable={true}
                                value={movement.driver}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Internal Supplier Cost Override</Form.Label>
                                <Form.Checkbox
                                    name={"supplier_cost_override"}
                                    checked={movement.supplier_cost_override}
                                    onChange={onCostOverrideCheck}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Internal Supplier Charge</Form.Label>
                                <Form.Input
                                    name={"internal_charge"}
                                    onChange={onChange}
                                    type={"number"}
                                    value={movement.internal_charge}
                                />
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Field>
                                <Form.Label>Comments</Form.Label>
                                <Form.Textarea
                                    name={"comments"}
                                    onChange={onChange}
                                    value={movement.comments}
                                />
                            </Form.Field>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        {movement.supplier_status === "EXTERNAL" &&
                            <Columns.Column>
                                <Form.Label>External Supplier</Form.Label>
                                <AsyncTypeahead
                                  useCache={false}
                                  isLoading={loading}
                                  id="typeahead"
                                  labelKey="display_name"
                                  minLength={2}
                                  name={"external_supplier"}
                                  onSearch={handleSupplierSearch}
                                  onChange={onExternalSupplierChange}
                                  placeholder={`Search Supplier`}
                                  options={searchData}
                                  ref={typeahead => setTypeahead(typeahead)}
                                  className="typeahead"
                                />
                            </Columns.Column>
                        }
                        {movement.supplier_status === "EXTERNAL" &&
                            <Columns.Column>
                                <Form.Label>External Supplier Charge Override</Form.Label>
                                <Form.Checkbox
                                    checked={movement.external_supplier_charge_override}
                                    name={"external_supplier_charge_override"}
                                    onChange={onCostOverrideCheck}
                                />
                            </Columns.Column>
                        }
                        {movement.supplier_status === "EXTERNAL" &&
                            <Columns.Column>
                                <Form.Label>External Supplier Charge</Form.Label>
                                <Form.Input
                                    value={movement.external_supplier_charge}
                                    name={"external_supplier_charge"}
                                    onChange={onChange}
                                />
                            </Columns.Column>
                        }
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                onClick={() => {setOpen(false)}}
                                fullwidth
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                onClick={save}
                                fullwidth
                            >
                                Save
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
                <CreateNewContactModal
                    open={customerCreateModalOpen}
                    setOpen={setCustomerCreateModalOpen}
                />
            </Modal.Content>
        </Modal>
    )



}